export const COLUMN_IDS = {
  INDICATOR: 'ratioName',
  UNIT: 'unit',
  YEAR: 'YEAR',
  PERCENT_CHANGE: 'percentChange',
  TRENDLINE: 'values',
}

export const UNIT_FINANCIAL = {
  VND: 'VND',
  PERCENT: '%',
}
